import isEmpty from "lodash/isEmpty";
import ellipse from "assets/icons/ellipse.svg";
import checkCircle from "assets/icons/check-circle.svg";
import exclamationCircle from "assets/icons/exclamation-circle.svg";
import style from "./style.module.css";

enum ValidPW {
  minCharacters = "MINIMUM_CHARACTERS",
  hasUpperCase = "HAS_UPPER_CASE",
  hasLowerCase = "HAS_LOWER_CASE",
  hasNumber = "HAS_NUMBER"
}

export const PASSWORD_REQUIREMENTS = {
  [ValidPW.minCharacters]: {
    key: ValidPW.minCharacters,
    message: "Minimum 10 characters",
    regex: /^.{10,}$/g
  },
  [ValidPW.hasUpperCase]: {
    key: ValidPW.hasUpperCase,
    message: "At least 1 uppercase letter",
    regex: /(?=.*[A-Z])/g
  },
  [ValidPW.hasLowerCase]: {
    key: ValidPW.hasLowerCase,
    message: "At least 1 lowercase letter",
    regex: /(?=.*[a-z])/g
  },
  [ValidPW.hasNumber]: {
    key: ValidPW.hasNumber,
    message: "At least 1 number",
    regex: /(?=.*\d)/g
  }
};

interface PasswordRequirementsHelpType {
  input?: string;
}
const PasswordRequirementsHelp = ({ input = "" }: PasswordRequirementsHelpType) => {
  return (
    <ul className={style["password-requirements-ul"]}>
      {Object.values(PASSWORD_REQUIREMENTS).map(pr => {
        const regex = pr.regex;
        const notFulfilled = isEmpty(input.match(regex));
        return (
          <li key={pr.key} className={style["password-requirements-li"]}>
            {notFulfilled ? (
              <img src={ellipse} style={{ marginRight: 8 }} alt="requirement not fulfilled" />
            ) : (
              <img src={checkCircle} style={{ marginRight: 8 }} alt="requirement fulfilled" />
            )}
            <span>{pr.message}</span>
          </li>
        );
      })}
    </ul>
  );
};

interface PasswordMatchType {
  password?: string;
  confirm?: string;
}
export const PasswordMatch = ({ password = "", confirm = "" }: PasswordMatchType) => {
  const match = password === confirm;

  if (isEmpty(password) && isEmpty(confirm)) {
    return null; // cannot show 'Passwords match' tick
  }
  return (
    <ul className={style["password-requirements-ul"]}>
      {match ? (
        <li className={style["password-requirements-li"]}>
          <img src={checkCircle} style={{ marginRight: 8 }} alt="passwords match" />
          <span>{"Passwords match"}</span>
        </li>
      ) : (
        <li className={style["password-requirements-li"]}>
          <img src={exclamationCircle} style={{ marginRight: 8 }} alt="passwords do not match" />
          <span>{"Passwords do not match"}</span>
        </li>
      )}
    </ul>
  );
};

export default PasswordRequirementsHelp;
